import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Payment contacts", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5 text-white",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" })
], -1)
const _hoisted_5 = { class: "w-full mt-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "Emails to contact:", -1)
const _hoisted_7 = { class: "w-full flex flex-wrap space-x-1 space-y-1 mt-3" }
const _hoisted_8 = {
  key: 1,
  class: ""
}
const _hoisted_9 = { class: "flex flex-row justify-betwee items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "w-full font-semibold" }, "Payment contacts", -1)
const _hoisted_11 = { class: "w-full flex flex-row justify-end space-x-2" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 block mb-2" }, "Emails to contact:", -1)
const _hoisted_14 = { class: "w-full flex flex-wrap" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
}, null, -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "w-8/12 flex flex-row mt-5" }
const _hoisted_20 = ["pattern"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-4 w-4 mr-2",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 4v16m8-8H4"
  })
], -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Add email ")
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = {
  key: 0,
  class: "text-xs text-orange-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (!_ctx.isEditing)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Button, {
            onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isEditing = true)),
            sizeLabel: "text-sm",
            label: "Edit contacts",
            variant: "contained"
          }, {
            startIcon: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payment_contacts, (item, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                class: "flex flex-row justify-center items-center px-2 py-1 rounded-lg bg-purple-100 text-primary mx-1 my-1"
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Button, {
              onOnClick: _ctx.onCancel,
              sizeLabel: "text-sm",
              label: "Cancel",
              variant: "outlined"
            }, null, 8, ["onOnClick"]),
            _createVNode(_component_Button, {
              onOnClick: _ctx.saveChanges,
              sizeLabel: "text-sm",
              label: "Save changes",
              variant: "contained",
              disabled: _ctx.isLoadingButton
            }, null, 8, ["onOnClick", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payment_contacts, (item, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                class: "flex flex-row justify-center items-center px-2 py-1 rounded-lg bg-purple-100 text-primary mx-1 my-1"
              }, [
                _createTextVNode(_toDisplayString(item) + " ", 1),
                (_openBlock(), _createElementBlock("svg", {
                  onClick: ($event: any) => (_ctx.deleteContacts(index)),
                  class: "h-4 w-4 ml-3",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, _hoisted_18, 8, _hoisted_15))
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              type: "email",
              pattern: _ctx.pattern,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
              placeholder: "Email...",
              class: "w-full bg-gray-200 py-2 px-3 rounded-l border border-gray-200 text-sm focus:outline-none focus:bg-gray-100"
            }, null, 8, _hoisted_20), [
              [_vModelText, _ctx.email]
            ]),
            _createElementVNode("button", {
              class: "w-1/5 flex flex-row p-2 border rounded-r items-center justify-center border border-purple-400 text-primary text-sm cursor-pointer",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addEmail && _ctx.addEmail(...args)))
            }, _hoisted_23)
          ]),
          (_ctx.emailError)
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Please enter a valid email"))
            : _createCommentVNode("", true)
        ])
      ]))
}